@if (slidePanelService.state$ | async; as state) {
  @if (state.portal) {
    <div
      class="slide-panel"
      [style.width]="state.width"
      [@slideIn]="'open'"
    >
      <header class="slide-panel-header">
        <span class="slide-panel-title">{{ state.title }}</span>
        <button
          mat-icon-button
          type="button"
          class="slide-panel-close"
          (click)="slidePanelService.close()"
          [attr.aria-label]="'shared.common.close' | transloco"
        >
          <mat-icon>close</mat-icon>
        </button>
      </header>
      <div class="slide-panel-body">
        <ng-template [cdkPortalOutlet]="state.portal"></ng-template>
      </div>
    </div>
  }
}
